module.exports = __webpack_public_path__ + "img/device_c1_three_en.fad62cf8.png";